declare const chrome: any;

/**
 * Sends logout notification to Chrome extension
 * @param {string} [extensionId] - ID of the Chrome extension to communicate with
 * @return {void}
 */
const logOutChrome = (extensionId: string | undefined) => {
  if (!extensionId || !chrome.runtime?.sendMessage) return;

  const message = {
    type: 'SPROUTS_AUTH',
    action: 'logoutToken',
    payload: {
      timestamp: Date.now(),
      source: 'web_app',
    },
  };

  try {
    chrome.runtime.sendMessage(extensionId, message);
  } catch (error) {
    console.error('chrome.runtime.sendMessage is not available.');
  }
};

export default logOutChrome;
